// import { conceptMappingMessagesEn } from '@verantos-dev/feature-concept-mapping';
// import { datasetDeliveryMessagesEn } from '@verantos-dev/feature-dataset-delivery';
import { dataGridMessagesEn } from '@verantos-dev/shared-components';

import { rolesEn } from '../core/auth';
import { appLayoutMessagesEn, enterpriseLoginMessagesEn } from '../core/localization';
import { adminCommonMessagesEn } from '../features/admin-common/locale/adminCommonMessagesEn';
import { adminProjectsMessagesEn } from '../features/admin-projects/locale/adminProjectsMessagesEn';
import { annotationScreenMessagesEn } from '../features/annotation/locale/annotationScreenMessagesEn';
import { annotatorProjectsMessagesEn } from '../features/annotator-projects/locale/annotatorProjectsMessagesEn';
import { annotatorQueueMessagesEn } from '../features/annotator-queue/locale/annotatorQueueMessagesEn';
import { createProjectWizardMessagesEn } from '../features/create-project-wizard/locale/createProjectWizardMessagesEn';
import { annotationDashboardMessagesEn } from '../features/dashboard/locale/annotationDashboardMessagesEn';
import { metricsMessagesEn } from '../features/metrics/locale/metricsMessagesEn';
import { supervisorScreenMessagesEn } from '../features/supervisor/locale/supervisorScreenMessagesEn';
import { supervisorProjectsMessagesEn } from '../features/supervisor-projects/locale/supervisorProjectsMessagesEn';
import { supervisorQueueMessagesEn } from '../features/supervisor-queue/locale/supervisorQueueMessagesEn';
import { workspaceCommonMessagesEn } from '../features/workspace-common/locale/workspaceCommonMessagesEn';
import { coreAnnotationToolSidebarMessagesEn } from '../lib';

export default {
  // CORE MESSAGES
  ...rolesEn,
  ...appLayoutMessagesEn,
  ...enterpriseLoginMessagesEn,
  ...dataGridMessagesEn,

  // FEATURE MESSAGES
  ...coreAnnotationToolSidebarMessagesEn,
  ...annotationDashboardMessagesEn,
  ...annotatorQueueMessagesEn,
  ...annotationScreenMessagesEn,
  ...supervisorQueueMessagesEn,
  ...supervisorScreenMessagesEn,
  ...workspaceCommonMessagesEn,
  ...createProjectWizardMessagesEn,
  ...adminProjectsMessagesEn,
  ...adminCommonMessagesEn,
  ...annotatorProjectsMessagesEn,
  ...supervisorProjectsMessagesEn,
  ...metricsMessagesEn,
};
